import React, { createContext, Dispatch, ReactNode, SetStateAction, useContext, useMemo, useState } from 'react';

type ReadonlyState = {
    readOnly: boolean;
    setReadOnly: Dispatch<SetStateAction<boolean>>;
};

export const ReadOnlyContext = createContext<ReadonlyState>({
    readOnly: false,
    setReadOnly: () => undefined,
});

export const ReadOnlyContextProvider = ({ children }: { children: ReactNode }) => {
    const [readOnly, setReadOnly] = useState<boolean>(false);

    return (
        <ReadOnlyContext.Provider
            value={useMemo(
                () => ({
                    readOnly,
                    setReadOnly,
                }),
                [readOnly, setReadOnly],
            )}
        >
            {children}
        </ReadOnlyContext.Provider>
    );
};

export const useReadOnlyContext = () => useContext(ReadOnlyContext);
